import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Paper, Tab, Tabs } from "@mui/material";
import ListFilters from "./ListFilters/ListFilters";
import WorkshopList from "./WorkshopList";
import {
  loadExpiredWorkshops,
  selectFilteredWorkshops,
} from "../../state/workshopSlice";
import PlayArrowOutlinedIcon from "@mui/icons-material/PlayArrowOutlined";
import EventBusyOutlinedIcon from "@mui/icons-material/EventBusyOutlined";

const ListContainer = () => {
  const dispatch = useDispatch();
  const { upcomingWorkshops, expiredWorkshops } = useSelector(
    selectFilteredWorkshops
  );
  const [currentTab, setCurrentTab] = useState(0);

  const handleTabChange = (e, index) => {
    setCurrentTab(index);
    if (index === 1) {
      //expired workshops
      if (expiredWorkshops.length <= 0) dispatch(loadExpiredWorkshops());
    }
  };

  return (
    <Paper
      variant="outlined"
      sx={{
        width: 1 / 3,
        padding: "0.5rem",
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <ListFilters />
      <Tabs value={currentTab} onChange={handleTabChange} variant="fullWidth">
        <Tab
          label="Upcoming"
          icon={<PlayArrowOutlinedIcon />}
          iconPosition="start"
        />
        <Tab
          label="Expired"
          icon={<EventBusyOutlinedIcon />}
          iconPosition="start"
        />
      </Tabs>
      {currentTab === 0 && <WorkshopList workshops={upcomingWorkshops} />}
      {currentTab === 1 && (
        <WorkshopList workshops={expiredWorkshops} showMore={true} />
      )}
    </Paper>
  );
};

export default ListContainer;
